import {defer} from 'lodash';
import React, {useCallback, useEffect, useState} from 'react';
import ActiveFilterButton from '../ActiveFilterButton/ActiveFilterButton';

const TextFilter = props => {
    const {event, filterParams} = props,
        [text, setText] = useState(),
        active = !!text?.toString().length;

    useEffect(() => {
        if (text != filterParams?.text) setText(filterParams?.text);
    }, [filterParams]);

    const handleClick = useCallback(() => {
        setText();
        defer(() => {
            app.store.dispatch(
                app.actions.participants.setFilterParams(event.id, {
                    ...(filterParams || {}),
                    text: '',
                })
            );
        });
    }, [filterParams]);

    return (
        <ActiveFilterButton event={event} onClick={handleClick} visible={active}>
            &ldquo;{text}&rdquo;
        </ActiveFilterButton>
    );
};

export default TextFilter;
